import React, { useEffect, useState } from 'react'
import {
	Box,
	HStack,
	IconButton,
	Input,
	Select,
	Stack,
	Spinner,
	Center,
	Text,
	Flex,
	Alert,
	Icon,
	Collapse,
	Table,
		Thead,
		Tr,
		Th,
		Tbody,
		Td,
		Button,
		VStack,
		SimpleGrid,
	Image
} from '@chakra-ui/react'
import {
	Pagination,
	usePagination,
	PaginationNext,
	PaginationPage,
	PaginationPrevious,
	PaginationContainer,
	PaginationPageGroup,
	PaginationSeparator,
} from '@ajna/pagination'
import AdminBlockCard from '../../components/AdminBlockCard'
import AdminBreadcrumb from '../../components/AdminBreadcrumb'
import { GoSearch } from 'react-icons/go'
import AdminClaimedBusinessCard from '../../components/AdminClaimedBusinessCard'
import { getRequest } from '../../services/base.service'
import { IoIosArrowBack } from 'react-icons/io'
import { IoIosArrowForward } from 'react-icons/io'
import { FiFilter, FiEye } from 'react-icons/fi'
import { useDispatch } from 'react-redux'
import {
	setAdminSidebarFalseOnUrlChange,
	setCurrentPageHeading,
} from '../../redux/common/commonActions'
import SearchBox from '../../components/SearchBox'
import { Link } from 'react-router-dom';

const breadCrumb = [
	{ label: 'Dashboard', isCurrentPage: false, link: '/admin/dashboard' },
	{ label: 'Claimed List', isCurrentPage: true },
]
const ClaimedList = () => {
	const [claimList, setClaimList] = useState(null)
	const [showMobileActions, setShowMobileActions] = useState(false)
	const [spinner, setSpinner] = useState({ status: true })
	const [queryParams, setQueryParams] = useState(null)
	const [countryList, setCountryList] = useState([])
	const [stateList, setStateList] = useState([])
	const [selectedCountry, setSelectedCountry] = useState(null)
	const [paginationProperty, setPaginationProperty] = useState({
		total: 1,
		currentPage: 1,
		pageSize: 10,
	})
	const {
		pages,
		pagesCount,
		currentPage,
		setCurrentPage,
		isDisabled,
		setPageSize,
		pageSize
	} = usePagination({
		total: paginationProperty.total,
		limits: {
			outer: 2,
			inner: 2,
		},
		initialState: {
			pageSize: paginationProperty.pageSize,
			isDisabled: false,
			currentPage: 1,
		},
	})
	const dispatch = useDispatch()
	useEffect(() => {
		dispatch(setCurrentPageHeading('Claimed List'))
		dispatch(setAdminSidebarFalseOnUrlChange())
	}, [])
	useEffect(() => {
		fetchClaimList({ page: currentPage, limit: pageSize })
		fetchCountryList()
	}, [currentPage, pageSize])
	useEffect(() => {
			if (selectedCountry) {
				fetchStateList();
			}
	}, [selectedCountry])

	const fetchClaimList = (params = {}) => {
		setSpinner({ status: true })
		getRequest('admin/claims', { params })
			.then((res) => {
				setClaimList(res.result?.data)
				setPaginationProperty({
					total: res.result.total,
					currentPage: res.result.current_page,
					pageSize: res.result.per_page,
				})
				setPageSize(res.result.per_page)
				setSpinner({ status: false })
			})
			.catch((err) => {
				console.log('ERR: ', err)
			})
	}
	const fetchCountryList = () => {
				getRequest(`countries`)
					.then((res) => setCountryList(res.result))
					.catch((err) => console.log('ERR: ', err))
	}
	const fetchStateList = () => {
			getRequest(`states/${selectedCountry}`)
				.then((res) => {
					setStateList(res.result?.states)
				})
				.catch((err) => {
					console.log('ERR: ', err)
				})
	}
	const handlePageChange = (nextPage) => {
		setCurrentPage(nextPage)
	}

	const handleSearch = (e) => {
		e.preventDefault()
		setCurrentPage(1)
		fetchClaimList({ ...queryParams, page: 1, limit: pageSize })
	}

	function handleChange(key, event) {
		setQueryParams({ ...queryParams, [key]: event.target.value })
		setSpinner({ status: true })
		setCurrentPage(1)
		fetchClaimList({ ...queryParams, [key]: event.target.value, page: 1 })
	}
	const formatDate = (dateString) => {
			const date = new Date(dateString);
			const day = date.getDate();
			const month = date.toLocaleString('en-GB', { month: 'long' });
			const year = date.getFullYear();
			return `${day} ${month}, ${year}`;
	};
	const handleReset = () => {
		const defaultQuery = { keyword: '', country_id: '', state_id: '', industry_id: '', status: '', sort: '', address_keyword: '' }
		setQueryParams(defaultQuery)
		setCurrentPage(1)
		fetchClaimList({ ...defaultQuery, page: 1 })
	}

	return (
		<>
			<AdminBreadcrumb items={breadCrumb} />
			<SearchBox
					primaryActions={
						<>
							<HStack as={'form'} w="100%">
										<Input
											placeholder="Search..."
											w={['100%']} 
											size={'md'}
											borderColor={'gray.300'}
											rounded={'md'}
											onChange={(e) => {
												setQueryParams({
													...queryParams,
													keyword: e.target.value,
												})
											}}
										/>
										{/* <Box>
											<IconButton
												aria-label="Search"
												size={'md'}
												icon={<GoSearch />}
												variant={'brand'}
												type="submit"
												onClick={handleSearch}
											/>
										</Box> */}
							</HStack>
						</>
					}
					secondaryActions={
						<VStack as="form" spacing={4} w="100%" align="stretch">
							<SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} w="100%">
								<Select
									placeholder="Country"
									size="md"
									rounded={'md'}
									borderColor="gray.300"
									value={queryParams?.country_id || ''}
									// onChange={(e) => handleChange('country_id', e)}
									onChange={(e) => {
													setQueryParams({
														...queryParams,
														country_id: e.target.value,
													})
													setSelectedCountry(e.target.value)
									}}
								>
									{countryList.map((country) => (
									<option key={country.id} value={country.id}>
										{country.name}
									</option>
									))}
								</Select>
								<Select
									placeholder="State"
									size="md"
									rounded={'md'}
									borderColor="gray.300"
									value={queryParams?.state_id || ''}
									onChange={(e) => {
													setQueryParams({
														...queryParams,
														state_id: e.target.value,
													})
									}}
								>
									{stateList.map((state) => (
									<option key={state.id} value={state.id}>
										{state.name}
									</option>
									))}
								</Select>
								<Input
									placeholder="Enter Area"
									size="md"
									rounded={'md'}
									borderColor="gray.300"
									value={queryParams?.address_keyword || ''}
									onChange={(e) =>
										setQueryParams({
											...queryParams,
											address_keyword: e.target.value,
										})
									}
								/>
								<Select
									placeholder="Industry"
									size="md"
									rounded={'md'}
									borderColor="gray.300"
									value={queryParams?.industry_id || ''}
									onChange={(e) =>
										setQueryParams({
											...queryParams,
											industry_id: e.target.value,
										})
									}
								>
									{/* {industryList.map((industry) => (
									<option key={industry.id} value={industry.id}>
										{industry.name}
									</option>
									))} */}
								</Select>
								<Select
								placeholder="Status"
								size="md"
								rounded={'md'}
								borderColor="gray.300"
								value={queryParams?.status || ''}
								onChange={(e) =>
										setQueryParams({
											...queryParams,
											status: e.target.value,
										})
								}
								>
								<option value={'pending'}>Pending</option>
								<option value={'approved'}>Approved</option>
								<option value={'declined'}>Declined</option>
								<option value={'blocked'}>Blocked</option>
								</Select>
								<Select
									placeholder="Sort By"
									size="md"
									rounded={'md'}
									borderColor="gray.300"
									value={queryParams?.sort || ''}
									// onChange={(e) => handleChange('sort', e)}
									onChange={(e) =>
										setQueryParams({
											...queryParams,
											sort: e.target.value,
										})
									}
								>
									<option value={'desc'}>New</option>
									<option value={'asc'}>Older</option>
								</Select>
							
							</SimpleGrid>
						
							{/* Buttons */}
							<HStack justify="flex-end" spacing={4}>
							<Button 
								variant="outline"
								colorScheme="gray" 
								size="md"				
								rounded={'md'}
								onClick={handleReset}
							>
								Reset
							</Button>
							<Button 
								variant={'brand'}
								size="md"
								rounded={'md'}
								type="submit" 
								onClick={handleSearch}
							>
								Search
							</Button>
							</HStack>
						</VStack>
					}>
			</SearchBox>
			<Box py={'7'}>
				<AdminBlockCard
					title={'Claimed List'}
					// primaryActions={
					// 	<>
					// 	{/* <HStack> */}
					// 		{/* <Select
					// 			display={['none', 'none', 'none', 'flex']}
					// 			placeholder="Status"
					// 			w={'120px'}
					// 			size={'sm'}
					// 			borderColor={'gray.300'}
					// 			value={queryParams?.status}
					// 			onChange={(e) => handleChange('status', e)}
					// 		>
					// 			<option value={'pending'}>Pending</option>
					// 			<option value={'approved'}>Approved</option>
					// 			<option value={'declined'}>Declined</option>
					// 			<option value={'blocked'}>Blocked</option>
					// 		</Select>
					// 		<Select
					// 			display={['none', 'none', 'none', 'flex']}
					// 			placeholder="Sort By"
					// 			w={'120px'}
					// 			size={'sm'}
					// 			borderColor={'gray.300'}
					// 			value={queryParams?.sort}
					// 			onChange={(e) => handleChange('sort', e)}
					// 		>
					// 			<option value={'desc'}>New</option>
					// 			<option value={'asc'}>Older</option>
					// 		</Select> */}
					// 		<Input
					// 			placeholder="Search..."
					// 			w={['100%', '100%', '100%', '850px']}
					// 			size={'sm'}
					// 			borderColor={'gray.300'}
					// 			onChange={(e) => {
					// 				setQueryParams({ ...queryParams, keyword: e.target.value })
					// 			}}
					// 		/>
					// 		{/* <Box> */}
					// 			<IconButton
					// 				aria-label="Search"
					// 				size={'sm'}
					// 				icon={<GoSearch />}
					// 				variant={'brand'}
					// 				type="submit"
					// 				onClick={handleSearch}
					// 			/>
					// 		{/* </Box> */}
					// 		<Icon
					// 			as={FiFilter}
					// 			display={[
					// 				'inline-block',
					// 				'inline-block',
					// 				'inline-block',
					// 				'none',
					// 			]}
					// 			onClick={() => {
					// 				setShowMobileActions(!showMobileActions)
					// 			}}
					// 			_hover={{ cursor: 'pointer' }}
					// 		/>
					// 	{/* </HStack> */}
					// 	</>
					// }
					// secondaryActions={
					// 	<HStack wrap="wrap" spacing={2}>
					// 		<Select
					// 			display={['none', 'none', 'none', 'flex']}
					// 			placeholder="Status"
					// 			w={'120px'}
					// 			size={'sm'}
					// 			borderColor={'gray.300'}
					// 			value={queryParams?.status}
					// 			onChange={(e) => handleChange('status', e)}
					// 		>
					// 			<option value={'pending'}>Pending</option>
					// 			<option value={'approved'}>Approved</option>
					// 			<option value={'declined'}>Declined</option>
					// 			<option value={'blocked'}>Blocked</option>
					// 		</Select>
					// 		<Select
					// 			display={['none', 'none', 'none', 'flex']}
					// 			placeholder="Sort By"
					// 			w={'120px'}
					// 			size={'sm'}
					// 			borderColor={'gray.300'}
					// 			value={queryParams?.sort}
					// 			onChange={(e) => handleChange('sort', e)}
					// 		>
					// 			<option value={'desc'}>New</option>
					// 			<option value={'asc'}>Older</option>
					// 		</Select>
					// 	</HStack>
					// }
					// mobileActions={
					// 	<Collapse
					// 		in={showMobileActions}
					// 		unmountOnExit={true}
					// 		animateOpacity
					// 	>
					// 		<HStack
					// 			display={[
					// 				`${showMobileActions ? 'flex' : 'none'}`,
					// 				`${showMobileActions ? 'flex' : 'none'}`,
					// 				`${showMobileActions ? 'flex' : 'none'}`,
					// 				'none',
					// 			]}
					// 			transition={'2s'}
					// 		>
					// 			<Select
					// 				placeholder="Filter By"
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.status}
					// 				onChange={(e) => handleChange('status', e)}
					// 			>
					// 				<option value={'pending'}>Pending</option>
					// 				<option value={'approved'}>Approved</option>
					// 				<option value={'declined'}>Declined</option>
					// 				<option value={'blocked'}>Blocked</option>
					// 			</Select>
					// 			<Select
					// 				placeholder="Sort By"
					// 				size={'sm'}
					// 				borderColor={'gray.300'}
					// 				value={queryParams?.sort}
					// 				onChange={(e) => handleChange('sort', e)}
					// 			>
					// 				<option value={'desc'}>New</option>
					// 				<option value={'asc'}>Older</option>
					// 			</Select>
					// 		</HStack>
					// 	</Collapse>
					// }
				>
					<Stack gap={2}>
						{spinner.status ? (
							<Center>
								<Spinner color="red.500" size="xl" speed="0.6s" />
							</Center>
						) : claimList.length > 0 ? (
							<>
								<Stack gap={2} rounded={'md'} overflow={'auto'} border={'1px'} borderColor="gray.200">
									{/* {claimList?.map((claim, index) => (
										<AdminClaimedBusinessCard
											key={index}
											companyName={claim?.name}
											data={claim}
										/>
									))} */}
								<Table
									variant="simple"
									w={'100%'}
								>
									<Thead bg="gray.100">
										<Tr>
											<Th>Logo</Th>
											<Th>Id</Th>
											<Th>Business Name</Th>
											<Th>Claimed By</Th>
											<Th>Address</Th>
											<Th>Created</Th>
											<Th>Last Updated</Th>
											<Th>Status</Th>
											<Th textAlign="right">Actions</Th>
										</Tr>
									</Thead>
									<Tbody>
										{claimList.map((claim, index) => (
											<Tr key={claim.id} bg={index % 2 === 0 ? 'gray.50' : 'white'}>
												<Td>
													<Image
														src={claim.business?.logo}
														alt={claim.business?.name}
														boxSize="50px"
														objectFit="contain"
													/>
												</Td>												
												<Td>{claim.id}</Td>
												<Td>{claim.business?.name}</Td>
												<Td>{claim.user?.name}</Td>
												<Td>{claim.business?.city?.name}, {claim.business?.state?.name}, {claim.business?.country?.name}</Td>
												<Td>{formatDate(claim.created_at)}</Td>											
												<Td>{formatDate(claim.updated_at)}</Td>
												<Td>{claim.status}</Td>
												<Td key={claim.id}>
													<HStack
														textAlign="right"
														align="right"
														justify="right"
														gap={2}
													>
														<Link to={`/admin/claimed-list/details/${claim?.business_id}?cId=${claim.id}`}>
															<FiEye cursor="pointer" />
														</Link>
													</HStack>
												</Td>												
											</Tr>
										))}
									</Tbody>									
								</Table>
								</Stack>
								<Flex justify="space-between" align="center" mt={4} px={2} flexWrap="wrap" gap={2}>
									<HStack>
										<Select
											size="sm"
											width="fit-content"
											rounded="md"
											value={paginationProperty.pageSize}
											onChange={(e) => {
												setPageSize(Number(e.target.value));
												setCurrentPage(1);
											}}
										>
											{[10, 20, 50, 100].map((size) => (
												<option key={size} value={size}>
												{size}
												</option>
											))}
										</Select>
										<Text fontSize="sm" color="gray.600">
										Viewing {(currentPage - 1) * paginationProperty.pageSize + 1} to{' '}
										{Math.min(currentPage * paginationProperty.pageSize, paginationProperty.total)} of{' '}
										{paginationProperty.total} data
										</Text>
									</HStack>									
									<Pagination
										pagesCount={pagesCount}
										currentPage={currentPage}
										isDisabled={isDisabled}
										onPageChange={handlePageChange}
									>
										<PaginationContainer align="center" justify="center" p={4}>
											<PaginationPrevious
												w={7}
												h={7}
												_hover={{
													bg: 'gray.100',
												}}
												bg="white"
												color="gray.700"
												_disable={{ bg: 'white' }}
											>
												<Text>
													<IoIosArrowBack />
												</Text>
											</PaginationPrevious>
											<PaginationPageGroup
												isInline
												align="center"
												mx="1"
												separator={
													<PaginationSeparator
														fontSize="sm"
														w={7}
														jumpSize={11}
													/>
												}
											>
												{pages.map((page) => (
													<PaginationPage
														w={7}
														h={7}
														bg="gray.200"
														border={'1px'}
														borderColor={'gray.300'}
														key={`pagination_page_${page}`}
														page={page}
														color={'black.500'}
														fontSize="sm"
														_hover={{
															bg: 'brand.600',
															color: 'white',
														}}
														_current={{
															bg: 'brand.500',
															fontSize: 'sm',
															color: 'white',
															borderColor: 'brand.500',
														}}
													/>
												))}
											</PaginationPageGroup>
											<PaginationNext
												w={7}
												h={7}
												_hover={{
													bg: 'gray.100',
												}}
												bg="white"
												color="gray.700"
												_disable={{ bg: 'white' }}
											>
												<Text>
													<IoIosArrowForward />
												</Text>
											</PaginationNext>
										</PaginationContainer>
									</Pagination>
								</Flex>
							</>
						) : (
							<Alert status="error">
								<Center h={'100%'} w={'100%'}>
									NO DATA FOUND.
								</Center>
							</Alert>
						)}
					</Stack>
				</AdminBlockCard>
			</Box>
		</>
	)
}

export default ClaimedList
